var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgUserSpinnerArrow20Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29 12h-.42A5.73 5.73 0 0 0 1 17.54 2.4 2.4 0 0 0 1 18h7.26A7 7 0 0 1 7 14a7.3 7.3 0 0 1 .29-2m1.17-2.27A7 7 0 0 1 14 7a5 5 0 0 1 .56 0A4.9 4.9 0 0 0 15 5a5 5 0 1 0-6.54 4.73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.2a4.2 4.2 0 0 1 0-8.4V8a6 6 0 1 0 6 6h-1.8a4.2 4.2 0 0 1-4.2 4.2",
    className: "secondary"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.852 15.032 1.816-1.832h-1.064a.8.8 0 1 1 0-1.6h3.016a.8.8 0 0 1 .8.8v2.992a.8.8 0 1 1-1.6 0v-1.04l-1.816 1.816a.8.8 0 0 1-1.128-1.128z",
    className: "arrow"
  })));
});